module.exports = __webpack_public_path__ + "img/paypal.dcecf52.svg";